/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SecurityIncognitoMaskIcon16Light } from './SecurityIncognitoMaskIcon16Light';
import { SecurityIncognitoMaskIcon16Regular } from './SecurityIncognitoMaskIcon16Regular';
import { SecurityIncognitoMaskIcon16Solid } from './SecurityIncognitoMaskIcon16Solid';
import { SecurityIncognitoMaskIcon20Light } from './SecurityIncognitoMaskIcon20Light';
import { SecurityIncognitoMaskIcon20Regular } from './SecurityIncognitoMaskIcon20Regular';
import { SecurityIncognitoMaskIcon20Solid } from './SecurityIncognitoMaskIcon20Solid';
import { SecurityIncognitoMaskIcon24Regular } from './SecurityIncognitoMaskIcon24Regular';
import { SecurityIncognitoMaskIcon24Solid } from './SecurityIncognitoMaskIcon24Solid';
import { SecurityIncognitoMaskIcon32Regular } from './SecurityIncognitoMaskIcon32Regular';
import { SecurityIncognitoMaskIcon64Regular } from './SecurityIncognitoMaskIcon64Regular';
var sizes = {
    16: {
        light: SecurityIncognitoMaskIcon16Light,
        regular: SecurityIncognitoMaskIcon16Regular,
        solid: SecurityIncognitoMaskIcon16Solid,
    },
    20: {
        light: SecurityIncognitoMaskIcon20Light,
        regular: SecurityIncognitoMaskIcon20Regular,
        solid: SecurityIncognitoMaskIcon20Solid,
    },
    24: {
        regular: SecurityIncognitoMaskIcon24Regular,
        solid: SecurityIncognitoMaskIcon24Solid,
    },
    32: {
        regular: SecurityIncognitoMaskIcon32Regular,
    },
    64: {
        regular: SecurityIncognitoMaskIcon64Regular,
    },
};
export var SecurityIncognitoMaskIcon = forwardRef('SecurityIncognitoMaskIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
